// extracted by mini-css-extract-plugin
export default {"sectionTitle":"PHSWP3","skeleton":"iJ3Hfe","hoverArea":"Doorcc"};